module.exports = __webpack_public_path__ + "img/4-2.1a73e00e.jpg";